export default () => ({
    icons: {
        home: `<svg width="28px" height="32px" viewBox="0 0 28 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M13.5207114,0 C6.05404458,0 4.20996571e-13,6.05404458 4.20996571e-13,13.5221336 C4.20996571e-13,17.7500448 2.25973338,21.1736894 4.97635567,24 C6.94161793,26.0472184 13.5207114,32 13.5207114,32 C13.5207114,32 20.6375116,25.5512895 21.2736005,24.9166228 C24.2694405,21.919396 27.0417784,18.0817782 27.0417784,13.5221336 C27.0417784,6.05404458 20.9877338,0 13.521067,0 L13.5207114,0 Z" id="polypath-1"></path>
        <polygon id="polypath-3" points="20.0774504 13.1556013 20.0774504 20.6836665 15.4060558 20.6836665 15.4060558 15.1056994 12.5939836 15.1056994 12.5939836 20.6836665 7.91943167 20.6836665 7.91943167 13.1556013 6 13.1556013 13.99852 5 16.8784371 7.93540868 16.8784371 6.43686035 19.1185436 6.43686035 19.1185436 10.2186534 22 13.1556013"></polygon>
    </defs>
    <g id="🎨-Style-Guide" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Status-Indicator-Colors" transform="translate(-72.000000, -338.000000)">
            <g id="Group-18" transform="translate(72.000000, 338.000000)">
                <g id="Group-17" transform="translate(0.000000, 0.000000)">
                    <g id="Group-16" transform="translate(0.000000, 0.000000)">
                        <mask id="mask-2" fill="white">
                            <use xlink:href="#polypath-1"></use>
                        </mask>
                        <use id="Fill-1" fill="#9F1F63" xlink:href="#polypath-1"></use>
                        <mask id="mask-4" fill="white">
                            <use xlink:href="#polypath-3"></use>
                        </mask>
                        <use id="Path" fill="#FFFFFF" xlink:href="#polypath-3"></use>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`,
        pin: `<svg width="33px" height="43px" viewBox="0 0 33 43" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-936.000000, -3210.000000)" fill="#0C2340">
            <g transform="translate(936.000000, 3210.000000)">
                <path d="M16.125,3.85469434e-13 C25.0305916,3.85469434e-13 32.25,7.21940841 32.25,16.125 C32.25,25.0305916 16.125,43 16.125,43 C16.125,43 2.82940338e-13,25.0305916 2.82940338e-13,16.125 C2.82940338e-13,7.21940841 7.21940841,3.85469434e-13 16.125,3.85469434e-13 Z M16.125,6.40865385 C11.3296815,6.40865385 7.44230769,10.2960276 7.44230769,15.0913462 C7.44230769,19.8866647 11.3296815,23.7740385 16.125,23.7740385 C20.9203185,23.7740385 24.8076923,19.8866647 24.8076923,15.0913462 C24.8076923,10.2960276 20.9203185,6.40865385 16.125,6.40865385 Z"></path>
            </g>
        </g>
    </g>
</svg>`,
        pinSelected: `<svg width="33px" height="43px" viewBox="0 0 33 43" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink">
    <title>icons/location</title>
    <g id="Trial-Detail" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Trial-Details" transform="translate(-936.000000, -3210.000000)" fill="#00857C">
            <g id="icons/location" transform="translate(936.000000, 3210.000000)">
                <path d="M16.125,3.85469434e-13 C25.0305916,3.85469434e-13 32.25,7.21940841 32.25,16.125 C32.25,25.0305916 16.125,43 16.125,43 C16.125,43 2.82940338e-13,25.0305916 2.82940338e-13,16.125 C2.82940338e-13,7.21940841 7.21940841,3.85469434e-13 16.125,3.85469434e-13 Z M16.125,6.40865385 C11.3296815,6.40865385 7.44230769,10.2960276 7.44230769,15.0913462 C7.44230769,19.8866647 11.3296815,23.7740385 16.125,23.7740385 C20.9203185,23.7740385 24.8076923,19.8866647 24.8076923,15.0913462 C24.8076923,10.2960276 20.9203185,6.40865385 16.125,6.40865385 Z" id="Combined-Shape"></path>
            </g>
        </g>
    </g>
</svg>`,
    },
    loading: false,
    locations: [],
    locationName: '',
    locationSelected: null,
    markers: [],
    query: {
        lat: 0,
        lng: 0,
        newLocation: false,
        postId: 0,
        postType: 0,
        trials: [],
    },
    trialsSelected: [],
})
